module.exports = __webpack_public_path__ + "img/build_gray.af5b72fe.png";